import React from "react";

export default function Web_HTML_DOM() {
  return (
    <div>
      <h1>What is HTML DOM</h1>
      <p>
        Route: <code>/web/html-dom</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
